import { createContext } from 'react';
import { Employee, Store, StoresByBrand, UserInfo } from 'types';

interface UserProps extends Employee {
  isAdmin: boolean;
}

interface AuthContextData {
  user: UserProps;
  setUser: (user: UserInfo) => void;
  stores: StoresByBrand[];
  selectedStore: Store;
  setSelectedStore: (store: Store) => void;
  signIn: (
    form: { email: string; password: string },
    redirectPath?: string
  ) => void;
  signOut: () => void;
  signed: boolean;
}

export const AuthContext = createContext<AuthContextData>(
  {} as AuthContextData
);
